import React, { useState } from "react"
import { useSelector } from "react-redux"
import Counter from "./ui/Counter"
import { ResponsiveSidebar } from "./responsive-sidebar"
import tuneIcon from "../img/tune_icon.svg"
import TuneOptionsPanel from "./TuneOptionsPanel"
import { BasketItem, DropDownConfig } from "../types/basket"
import type { RootState } from "../store/types"

interface BasketItemActionsProps {
  quantity: number
  setCountValue: (count: number) => void
  dropDowns?: DropDownConfig[]
  imageUrl?: string
  item?: BasketItem
  tuneSettingsTitle?: string
  tuneSettingsFooter?: React.ReactNode
  tuneSettingsMobileFooter?: React.ReactNode
}

export default function BasketItemActions({
  dropDowns,
  imageUrl,
  item,
  quantity,
  setCountValue,
  tuneSettingsTitle,
  tuneSettingsFooter,
  tuneSettingsMobileFooter,
}: BasketItemActionsProps) {
  const direction = useSelector((state: RootState) => state.mode.direction)
  const [tuneOpen, setTuneOpen] = useState(false)
  const hasSelectableOption =
    Array.isArray(dropDowns) &&
    dropDowns.some(
      (dropDown) =>
        !dropDown?.isDisabled &&
        Array.isArray(dropDown.array) &&
        dropDown.array.some((option) => !option?.disabled)
    )

  return (
    <div className="flex w-full items-center justify-between">
      <Counter value={quantity} onChange={setCountValue} min={1} max={999} />
      {hasSelectableOption && (
        <ResponsiveSidebar
          open={tuneOpen}
          onOpenChange={setTuneOpen}
          trigger={
            <button
              className="bg-transparent border-none p-0 cursor-pointer"
              data-testid={`basket-item-tune-settings-${item?.item_id ?? "unknown"}`}
            >
              <img src={tuneIcon} alt="Tune settings" className="w-5 h-5" />
            </button>
          }
          footer={tuneSettingsFooter}
          mobileFooter={tuneSettingsMobileFooter}
          title={tuneSettingsTitle || item?.title}
          side={direction === "rtl" ? "left" : "right"}
        >
          <TuneOptionsPanel
            dropDowns={dropDowns}
            imageUrl={imageUrl}
            item={item}
          />
        </ResponsiveSidebar>
      )}
    </div>
  )
}
